// extracted by mini-css-extract-plugin
export default {"wrapper":"ck-z","reviewFormSuccess":"dk-z","header":"ek-z","message":"fk-z","paragraph":"gk-z","lottieContainer":"hk-z"};